/**
 * Labstep
 *
 * @module components/Molecule/Filter/Active/Post
 * @desc Active filter component for molecule_inchi
 */

import { ICONS } from 'labstep-web/constants/icons';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import {
  PostFilterExperimentWorkflowMolecule,
  PostFilterMolecule,
} from 'labstep-web/services/postFilter/filters/molecule';

const FILTERS = [
  PostFilterMolecule,
  PostFilterExperimentWorkflowMolecule,
];

export const MoleculeFilterActivePost = ({ onRemoveClick, node }) => {
  const filterActive = FILTERS.find((filter) => {
    return filter.isNodeActive(node);
  });
  if (!filterActive) {
    return null;
  }
  const { inchis } = filterActive.getAttributeValues(node);
  if (!inchis) {
    return null;
  }
  return (
    <RemoveLabel
      icon={ICONS.molecule.primary}
      name="Chemical Structure"
      onRemoveClick={onRemoveClick}
    />
  );
};
